'use client';

import { useEffect } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';

declare global {
    interface Window {
        fbq?: (...args: unknown[]) => void;
    }
}

/**
 * Fires `fbq('track', 'PageView')` on every App Router soft navigation.
 * The inline pixel snippet already fires one PageView on hard load; this
 * covers client-side transitions so Meta sees every route change.
 */
export function MetaPixelRouteTracker() {
    const pathname = usePathname();
    const searchParams = useSearchParams();

    useEffect(() => {
        if (typeof window === 'undefined') return;
        if (typeof window.fbq !== 'function') return;
        window.fbq('track', 'PageView');
    }, [pathname, searchParams]);

    return null;
}
